<template>
  <router-view/>
</template>

<script>
export default {
  data(){
    return{}
  },
  created(){
    // this.isLogin()
    this.setInterceptor()
  },
  methods:{
    isLogin(){ //判断是否已登录
      // let username = window.localStorage.getItem("username")
      // if(!username){
      //   this.$router.push({name: 'login'})
      // } else {
      //   this.setInterceptor()
      // }
    },
    //响应拦截器 => 无权限跳转
    setInterceptor() {
      this.$http.interceptors.response.use(
        response => {
          if(response.data.result_code === 2) {
            //没有权限-》跳转
            this.$router.push({name: 'login'})
            //请求不成功-》error message
            return Promise.reject(response.data)
            // this.$message.error("请先登录")
          }
          //将response体传递给then
          return response
        },
        error => {
          //error message
          return Promise.reject(error)
        }
      )
    }
  }
}
</script>

<style lang="scss">
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue